module.exports = __webpack_public_path__ + "img/Jump Casting11.5c5f0b3c.jpg";